// src/services/api/geo.api.ts
import {apiRequest} from "./client";
import { CountryItem, CityItem } from "../types/geo.types";

export const getCountriesRequest = async (): Promise<CountryItem[]> => {
    return apiRequest<CountryItem[]>("/geo/countries", {
        method: "GET",
        auth: true,
    });
};

export const getCitiesRequest = async (countryId?: string | null): Promise<CityItem[]> => {
    const query = new URLSearchParams();
    if (countryId) {
        query.set("country_id", countryId);
    }

    const qs = query.toString();
    return apiRequest<CityItem[]>(`/geo/cities${qs ? `?${qs}` : ""}`, {
        method: "GET",
        auth: true,
    });
};

// ---- Редактирование стран и городов (страница «Страны и города») ----

export interface CountryPayload {
    name_ru: string;
    name_en: string;
    name_de: string;
    name_ua?: string | null;
}

export interface CityPayload extends CountryPayload {
    country_id: string;
}

export const createCountryRequest = async (payload: CountryPayload): Promise<CountryItem> =>
    apiRequest<CountryItem>("/geo/countries", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
        auth: true,
    });

export const updateCountryRequest = async (
    countryId: string,
    payload: Partial<CountryPayload>,
): Promise<CountryItem> =>
    apiRequest<CountryItem>(`/geo/countries/${countryId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
        auth: true,
    });

export const createCityRequest = async (payload: CityPayload): Promise<CityItem> =>
    apiRequest<CityItem>("/geo/cities", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
        auth: true,
    });

export const updateCityRequest = async (cityId: string, payload: Partial<CityPayload>): Promise<CityItem> =>
    apiRequest<CityItem>(`/geo/cities/${cityId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
        auth: true,
    });
